// Copyright (c) 2022 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import Debit, {getDefaultState as getDebitDefaultState} from '@deere/cps-it.warranty-model-factory/lib/debit';
import t from 'tcomb';

const State = t.struct({
    amountDebit: t.Number,
    busyCounter: BusyCounter,
    debit: Debit,
    isConfirmationModalVisible: t.Boolean,
    isPercentageDebitModalVisible: t.Boolean
}, {
    name: 'State',
    strict: true
});

export const getDefaultState = () =>
    new State({
        amountDebit: 0,
        busyCounter: getBusyCounterDefaultState(),
        debit: getDebitDefaultState(),
        isConfirmationModalVisible: false,
        isPercentageDebitModalVisible: false
    });

export default State;



// WEBPACK FOOTER //
// ./src/tcsm/percentage-debit/state/index.js